import { Pipe, PipeTransform } from '@angular/core';

import { CommonService } from '../services/common.service';

@Pipe({
  name: 'getNavTitle',
})
export class GetNavTitlePipe implements PipeTransform {
  constructor(private cService: CommonService) {}

  transform(navItem: any) {
    return this.cService.getNavTitle(navItem);
  }
}
